import { createContext, useContext, useMemo, useState } from 'react';

export const defaultFilterValues = {
	globalRegion: [],
	setGlobalRegion: () => {},
	gender: [],
	setGender: () => {},
	ageGroup: [],
	setAgeGroup: () => {},
	educationLevel: [],
	setEducationLevel: () => {},
	income: [],
	setIncome: () => {},
	employmentStatus: [],
	setEmploymentStatus: () => {},
	urbanicity: [],
	setUrbanicity: () => {},
	isEmpty: true,
};

const FilterContext = createContext(defaultFilterValues);

export const FilterProvider = ({ children }) => {
	const [globalRegion, setGlobalRegion] = useState(defaultFilterValues.globalRegion);
	const [gender, setGender] = useState(defaultFilterValues.gender);
	const [ageGroup, setAgeGroup] = useState(defaultFilterValues.ageGroup);
	const [educationLevel, setEducationLevel] = useState(defaultFilterValues.educationLevel);
	const [income, setIncome] = useState(defaultFilterValues.income);
	const [employmentStatus, setEmploymentStatus] = useState(defaultFilterValues.employmentStatus);
	const [urbanicity, setUrbanicity] = useState(defaultFilterValues.urbanicity);

	// Every filter is now a list of selections, so "untouched" is simply "nothing chosen".
	const isEmpty = useMemo(
		() =>
			[
				globalRegion,
				gender,
				ageGroup,
				educationLevel,
				income,
				employmentStatus,
				urbanicity,
			].every((value) => value.length === 0),
		[
			globalRegion,
			gender,
			ageGroup,
			educationLevel,
			income,
			employmentStatus,
			urbanicity,
		]
	);

	const value = useMemo(
		() => ({ globalRegion, setGlobalRegion, gender, setGender, ageGroup, setAgeGroup, educationLevel, setEducationLevel, income, setIncome, employmentStatus, setEmploymentStatus, urbanicity, setUrbanicity, isEmpty }),
		// Stable identity: the chart's draw effect depends on this object, and a new
		// one every render would rebind and re-transition every shape.
		[globalRegion, setGlobalRegion, gender, setGender, ageGroup, setAgeGroup, educationLevel, setEducationLevel, income, setIncome, employmentStatus, setEmploymentStatus, urbanicity, setUrbanicity, isEmpty]
	);

	return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
};

export const useFilterContext = () => useContext(FilterContext);
